module.exports = __webpack_public_path__ + "img/1578804995.fdc48397.jpg";